export default "__VITE_ASSET__BcTs9E7D__"